// @ts-ignore - imported using Rollup json plugin
export { version as npmVersion } from '../package.json';
// In version 7, we changed the PostgreSQL indexes API
export const compatibilityVersion = 10;
